
const Config: any = {
	showError: {
		hasError:process.env.REACT_APP_SHOW_ERROR_PAGE
	}
};

export default Config;
